/* NOVYRE PDP 11/10 v8.2 — instant laden (#nvy-boot, async streaming boot) + draait ook op
   landingspagina's met een featured product + korting-berekening exact gelijk aan Shopify
   (korting per stuk = floor(prijs × kortingsfractie), niet round(prijs × rest)).
   v8.1: Private Sale-bundels (handle novyre-private-sale-*) hebben een vaste setprijs;
   daar geen 1/3/4-stuks widget — het script slaat die pagina's volledig over.
   v8.2 (6 aug 2026): optie-herkenning werkte alleen op de Nederlandse winkel. Zie
   indexOptions() — dit legde op /de/, /fr/ en /hr/ stelselmatig de verkeerde maat in de
   winkelwagen. */
(function(){
  'use strict';
  if(/^\/products\/novyre-private-sale/.test(location.pathname)){return;}
  var KLAVIYO='RbeEii', KREV='2025-04-15';
  var DEFAULT_PACKS=[{q:1,rate:1},{q:3,rate:0.667,disc:0.333,tagKey:'tag_popular',tag:'Meest gekozen',gold:true},{q:4,rate:0.625,disc:0.375,tagKey:'tag_best',tag:'Beste deal',gold:false}];
  /* Fallback op handle blijft staan voor het geval #nvy-boot de tag-vlag nog niet meestuurt. */
  var SWIM=['lumashape-bikini-set','lumashape-badpak'];
  var state={qty:3,colors:[]};
  var prod=null, colourName=null, sizeName=null;
  var CFG={};
  /* Vertaalde teksten komen uit snippets/js-variables.liquid: die zet nvy.buy.* uit
     locales/*.json als CFG.i18n in #nvy-boot. De Nederlandse fallback in elke
     T()-aanroep blijft staan, zodat de widget ook zonder vertalingen goed rendert. */
  function T(k,f){ var v=CFG.i18n&&CFG.i18n[k];
    if(v===undefined||v===null||v===''||/^Translation missing/.test(v)) return f;
    return v; }
  function TQ(q){ return T('qty_'+q, q===1?'1 stuk':q+' stuks'); }
  function isNL(){ return !CFG.locale||CFG.locale==='nl'; }
  var bisDone={};
  function noSetDiscount(){ return (CFG.no_set_discount!=null)?!!CFG.no_set_discount:!!(CFG.handle&&SWIM.indexOf(CFG.handle)>-1); }
  function packs(){ return noSetDiscount()?[{q:1,rate:1},{q:2,off:3995,tagKey:'tag_swim',tag:'WK Deal',gold:true}]:DEFAULT_PACKS; }
  function readCFG(){
    try{ var ce=document.getElementById('nvy-boot')||document.getElementById('nvy-cfg'); if(ce){ CFG=JSON.parse(ce.textContent)||{}; state.qty=packs()[1].q; } }catch(e){}
    /* Losse i18n-bron, zodat landingspagina's die #nvy-cfg gebruiken later kunnen
       aanhaken zonder de hele config te dupliceren. */
    if(!CFG.i18n){ try{ var ie=document.getElementById('nvy-i18n'); if(ie){ CFG.i18n=JSON.parse(ie.textContent)||{}; } }catch(e){} }
  }

  /* ---------------------------------------------------------------------------
     Optie-herkenning — v8.2, 6 aug 2026.

     De optienamen komen VERTAALD binnen op elke niet-Nederlandse markt: Farbe/Größe,
     Couleur/Taille, Boja/Veličina, Colour/Size. De oude test was /kleur|color/ en
     /maat|size/ en herkende daarvan alleen het Nederlands — zelfs het Engelse "colour"
     matcht /color/ niet. Gevolg: colourName en sizeName bleven null, en variantFor()
     gaf dan door zijn !colourName/!sizeName-kortsluiting ALTIJD variants[0] terug.
     De klant koos M en kreeg Creme/S, op novyre.de én op /fr/ en /hr/.

     Daarom nu drie stappen, van sterk naar zwak bewijs: naam, dan de wáárden, dan de
     overgebleven optie. De waarden-stap maakt dit taal-onafhankelijk, dus ook goed voor
     Sloveens, Bulgaars en Grieks zodra die markten opengaan.
     --------------------------------------------------------------------------- */
  var RE_KLEUR=/kleur|colou?r|farbe|couleur|colore|boja|barva|farve|f(ä|a)rg|цвят|χρώμα/;
  var RE_MAAT=/maat|size|gr(ö|oe|o)(ss|ß)e|taille|taglia|veli(č|c)ina|velikost|размер|μέγεθος/;
  var RE_MAATWAARDE=/^(xxs|xs|s|m|l|xl|xxl|xxxl|[2-9]xl)\+?$/i;
  function looksLikeSizes(o){
    var vals=(o&&o.values)||[];
    if(vals.length<2) return false;
    var hit=0;
    vals.forEach(function(v){ if(RE_MAATWAARDE.test(String(v).trim())) hit++; });
    return hit>=Math.ceil(vals.length*0.6);
  }
  function indexOptions(){
    if(!prod) return;
    colourName=null; sizeName=null;
    var opts=prod.options||[];
    /* 1. op naam, in elke taal die we voeren */
    opts.forEach(function(o,i){
      var n=(o.name||'').toLowerCase();
      if(!colourName&&RE_KLEUR.test(n)){ o._idx=i; colourName=o; }
      if(!sizeName&&RE_MAAT.test(n)){ o._idx=i; sizeName=o; }
    });
    /* 2. onbekende taal? herken de maat aan haar waarden (S/M/L/XL/3XL+) */
    if(!sizeName){
      opts.forEach(function(o,i){
        if(!sizeName&&o!==colourName&&looksLikeSizes(o)){ o._idx=i; sizeName=o; }
      });
    }
    /* 3. bij precies twee opties is de overgebleven optie de kleur. Bewust NIET bij
       drie of meer opties: dan weten we het niet en gokken we liever niet. */
    if(!colourName&&sizeName&&opts.length===2){
      opts.forEach(function(o,i){ if(o!==sizeName){ o._idx=i; colourName=o; } });
    }
  }
  function synthProd(){
    if(prod||!CFG.variants||!CFG.variants.length) return;
    var names=CFG.optionNames||[];
    var opts=names.map(function(nm,i){
      var seen={}, vals=[];
      CFG.variants.forEach(function(v){ var val=v['option'+(i+1)]; if(val!=null&&!seen[val]){ seen[val]=1; vals.push(val); } });
      return {name:nm,position:i+1,values:vals};
    });
    prod={title:CFG.title,type:CFG.type||'',options:opts,variants:CFG.variants};
    indexOptions();
  }
  readCFG(); synthProd();
  function esc(s){ var d=document.createElement('div'); d.textContent=s; return d.innerHTML; }
  function cfg(q){ var P=packs(); for(var i=0;i<P.length;i++){ if(P[i].q===q) return P[i]; } return P[0]; }
  /* Prijslabel volgt de presentment-valuta van de markt. De centen die hier binnenkomen zijn
     al door Liquid omgerekend (v.price in #nvy-boot); alleen het lábel was hardgecodeerd op
     € + komma-scheiding, waardoor DKK/GBP/CHF als euro's werden getoond. moneyFormat wordt
     synchroon gezet door snippets/js-variables.liquid, ruim vóór dit async script.
     De oude opmaak blijft de fallback: dit script draait ook op landingspagina's zonder
     FoxTheme, en een exception hier zou de hele koopzone prijsloos maken. */
  function eur(c){
    try{
      var F=window.FoxTheme, fmt=F&&F.settings&&F.settings.moneyFormat;
      if(fmt&&F.Currency&&typeof F.Currency.formatMoney==='function'){
        var s=F.Currency.formatMoney(c,fmt);
        if(s!=null&&String(s).trim()!=='') return String(s);
      }
    }catch(e){}
    return '€'+(c/100).toFixed(2).replace('.',',');
  }

  if(!prod){
    fetch(location.pathname.replace(/\/$/,'')+'.js').then(function(r){return r.json();}).then(function(p){
      if(prod) return;
      prod=p; indexOptions();
      tick();
    }).catch(function(){});
  }

  function selVariant(){
    var el=document.querySelector('variant-selects [data-selected-variant]');
    if(el){ try{ var v=JSON.parse(el.textContent); if(v&&v.id) return v; }catch(e){} }
    var inp=document.querySelector('form[id^="product-form"] input[name="id"]');
    if(inp&&prod){ var id=parseInt(inp.value,10); for(var i=0;i<prod.variants.length;i++){ if(prod.variants[i].id===id) return prod.variants[i]; } }
    var m=location.search.match(/[?&]variant=(\d+)/);
    if(m&&prod){ var vid=parseInt(m[1],10); for(var j=0;j<prod.variants.length;j++){ if(prod.variants[j].id===vid) return prod.variants[j]; } }
    return null;
  }
  function opt(v,o){ if(!v||!o) return null; return v['option'+(o._idx+1)] || (v.options?v.options[o._idx]:null); }
  function curColour(){ var v=selVariant(); return opt(v,colourName)|| (colourName&&colourName.values[0]); }
  function curSize(){ var v=selVariant(); return opt(v,sizeName)|| (sizeName&&sizeName.values[0]); }
  function variantFor(colour,size){
    if(!prod) return null;
    /* Vangnet: is de maat-optie niet herkend, geef dan NOOIT zomaar de eerste variant
       terug — dat was precies de bug van 6 aug. Val terug op wat de klant echt koos. */
    if(!sizeName) return selVariant();
    for(var i=0;i<prod.variants.length;i++){ var v=prod.variants[i];
      var okC=!colourName||v['option'+(colourName._idx+1)]===colour;
      var okS=v['option'+(sizeName._idx+1)]===size;
      if(okC&&okS) return v; }
    return null;
  }
  function imgFor(colour){
    if(!prod||!colourName) return null;
    for(var i=0;i<prod.variants.length;i++){ var v=prod.variants[i];
      if(v['option'+(colourName._idx+1)]===colour&&v.featured_image&&v.featured_image.src){ var s=v.featured_image.src; return s+(s.indexOf('?')>-1?'&':'?')+'width=64'; } }
    return null;
  }
  function unitCents(){ var v=selVariant(); return (v&&typeof v.price==='number')?v.price:(prod&&prod.variants[0]?prod.variants[0].price:2995); }
  function totalCents(){
    var u=unitCents(), size=curSize(), P=cfg(state.qty), sum=0, i;
    for(i=0;i<state.qty;i++){ var vv=variantFor(state.colors[i]||curColour(),size); var p=(vv&&typeof vv.price==='number')?vv.price:u; sum+=(P.off!=null)?p:((P.disc!=null)?(p-Math.floor(p*P.disc)):Math.round(p*P.rate)); }
    if(P.off!=null) sum-=P.off;
    return sum;
  }
  function perFor(q,u){ var P=cfg(q); if(P.off!=null) return u; if(P.disc!=null) return u-Math.floor(u*P.disc); return Math.round(u*P.rate); }
  function pctFor(q){ var P=cfg(q); return (P.rate!=null)?Math.round((1-P.rate)*100):0; }

  function firstUnavailable(){
    if(!prod||!colourName) return null;
    var size=curSize(), i;
    for(i=0;i<state.qty;i++){
      var c=state.colors[i]||curColour();
      var vv=variantFor(c,size);
      if(vv&&!vv.available){ return {colour:c,size:size,variant:vv}; }
    }
    return null;
  }

  function heroSync(){
    var u=unitCents(), q=state.qty, P=cfg(q);
    if(prod){ [].forEach.call(document.querySelectorAll('.nvy-ah__title'),function(t){ if(t.textContent.trim()!==prod.title) t.textContent=prod.title; }); }
    if(CFG.tagline){ [].forEach.call(document.querySelectorAll('.nvy-ah__sub'),function(s){ if(s.textContent.trim()!==CFG.tagline) s.textContent=CFG.tagline; }); }
    [].forEach.call(document.querySelectorAll('.nvy-ah__big'),function(b){ b.textContent=(P.off!=null||q===1)?eur(u):eur(perFor(q,u)); });
    [].forEach.call(document.querySelectorAll('.nvy-ah__pack'),function(p){
      var t=[].slice.call(p.childNodes).filter(function(n){return n.nodeType===3;})[0];
      if(!t) return;
      if(q===1){ t.textContent=' '+T('per_piece','per stuk')+' '; }
      else if(P.off!=null){ t.textContent=' · '+T('second_for','2e voor')+' '+eur(u-P.off)+' '; }
      else { t.textContent=' '+T('in_set','p/st in de %count%-set').replace('%count%',q)+' '; }
    });
    [].forEach.call(document.querySelectorAll('.nvy-ah__save'),function(s){
      if(q===1){ s.textContent=''; }
      else if(P.off!=null){ s.textContent='· '+T('save_lc','bespaar')+' '+eur(P.off); }
      else { s.textContent='· '+T('save_lc','bespaar')+' '+pctFor(q)+'%'; }
    });
    [].forEach.call(document.querySelectorAll('.nvy-ah__from'),function(f){ f.textContent=''; });
  }
  function injectUSPs(){
    /* Geen generieke Nederlandse fallback meer: die claims ('BH zonder cups') zijn
       onwaar voor slips en bodysuits. Zonder metafield-USPs renderen we niets. */
    if(!CFG.usps||CFG.usps.length<3) return;
    var usps=CFG.usps.slice(0,3);
    [].forEach.call(document.querySelectorAll('.nvy-ah__sub'),function(sub){
      if(sub.parentNode.querySelector('.nvy-usps')) return;
      var d=document.createElement('div'); d.className='nvy-usps';
      d.innerHTML='<span>'+esc(usps[0])+'</span><span>'+esc(usps[1])+'</span><span>'+esc(usps[2])+'</span>';
      sub.insertAdjacentElement('afterend',d);
    });
  }
  function swapFAQ(){
    if(!CFG.faq||!CFG.faq.length) return;
    [].forEach.call(document.querySelectorAll('.nvy-section--faq'),function(sec){
      if(sec.getAttribute('data-nvy-faq')) return;
      var items=[].slice.call(sec.querySelectorAll('[data-faq-item]'));
      if(!items.length) return;
      sec.setAttribute('data-nvy-faq','1');
      var list=items[0].parentNode, tpl=items[0];
      CFG.faq.forEach(function(f,i){
        var it=items[i];
        if(!it){ it=tpl.cloneNode(true); it.classList.remove('is-open'); list.appendChild(it);
          var btn=it.querySelector('button');
          if(btn){ btn.setAttribute('aria-expanded','false'); btn.addEventListener('click',function(){ it.classList.toggle('is-open'); btn.setAttribute('aria-expanded', it.classList.contains('is-open')?'true':'false'); }); }
        }
        var qs=it.querySelector('button span'); if(qs) qs.textContent=f.q;
        var ai=it.querySelector('[class*="__a-inner"]'); if(ai) ai.innerHTML='<p>'+esc(f.a)+'</p>';
      });
      for(var j=CFG.faq.length;j<items.length;j++){ items[j].style.display='none'; }
    });
  }
  function swapWhy(){
    if(!CFG.why||CFG.why.length<3) return;
    [].forEach.call(document.querySelectorAll('.nvy-wwli-grid'),function(grid){
      if(grid.getAttribute('data-nvy')) return;
      var cards=[].slice.call(grid.querySelectorAll('.nvy-wwli-card'));
      if(cards.length<3) return;
      grid.setAttribute('data-nvy','1');
      CFG.why.slice(0,3).forEach(function(w,i){
        var t=cards[i].querySelector('.nvy-wwli-title'); if(t) t.textContent=w.t;
        var b=cards[i].querySelector('.nvy-wwli-body'); if(b) b.textContent=w.b;
      });
    });
    [].forEach.call(document.querySelectorAll('[id*="below_why"]'),function(sec){
      if(sec.getAttribute('data-nvy-why')) return;
      var titles=[].slice.call(sec.querySelectorAll('h3'));
      if(titles.length>=3){
        sec.setAttribute('data-nvy-why','1');
        CFG.why.slice(0,3).forEach(function(w,i){
          if(titles[i]) titles[i].textContent=w.t;
          var p=titles[i]&&titles[i].nextElementSibling;
          if(p&&p.tagName==='P') p.textContent=w.b;
        });
      }
    });
  }
  function fixReviewHeading(){
    if(!isNL()) return;
    [].forEach.call(document.querySelectorAll('[id*="below_review_wall"]'),function(sec){
      [].forEach.call(sec.querySelectorAll('h1,h2,h3'),function(h){
        if(/in de praktijk/i.test(h.textContent)&&!h.getAttribute('data-nvy')){
          h.setAttribute('data-nvy','1');
          h.innerHTML='<span class="nvy-highlight">NOVYRE</span> in de praktijk';
        }
      });
    });
  }
  /* hideLumaOnly() stond hier: die verborg below_material en below_fit met
     style.display='none' op elk product behalve de Luma Contour. De bedoeling klopte
     (het gedeelde sjabloon nvy-luxe is met Contour-tekst geschreven), de uitvoering niet:
     ~21.000 tekens werden alsnog gerenderd en meegestuurd, en een eigen sjabloon met
     kloppende eigen tekst — product.nvy-luxe-forma.json — werd net zo hard verborgen.
     De poort staat nu vóór het renderen, in sections/nvy-material-story.liquid en
     sections/nvy-fit-architecture.liquid (instellingen gate_template + gate_handle). */
  function fixBrandClaims(){
    if(!isNL()) return;
    if(!CFG.handle||CFG.handle==='luma-contour-bh') return;
    [].forEach.call(document.querySelectorAll('[id*="below_final_cta"]'),function(sec){
      if(sec.getAttribute('data-nvy')) return; sec.setAttribute('data-nvy','1');
      var w=document.createTreeWalker(sec,NodeFilter.SHOW_TEXT),n;
      while((n=w.nextNode())){
        n.textContent=n.textContent.replace(/knelende beugels/gi,'ondergoed dat knelt').replace(/beugelvrij comfort/gi,'naadloos comfort');
      }
    });
    [].forEach.call(document.querySelectorAll('[id*="below_review_wall"] .nvy-sub'),function(p){
      if(p.getAttribute('data-nvy')) return; p.setAttribute('data-nvy','1');
      p.textContent=p.textContent.replace(/beugelvrij comfort/gi,'naadloos comfort');
    });
  }

  function subscribeBIS(variantId,email,panel){
    var btn=panel.querySelector('.nvy-bis__go'); if(btn) btn.disabled=true;
    var err=panel.querySelector('.nvy-bis__err'); if(err) err.remove();
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id='+KLAVIYO,{
      method:'POST',
      headers:{'Content-Type':'application/json','revision':KREV},
      body:JSON.stringify({data:{type:'back-in-stock-subscription',attributes:{profile:{data:{type:'profile',attributes:{email:email}}},channels:['EMAIL']},relationships:{variant:{data:{type:'catalog-variant',id:'$shopify:::$default:::'+variantId}}}}})
    }).then(function(r){
      if(r.status>=200&&r.status<300){
        bisDone[variantId]=true;
        var u=firstUnavailable();
        panel.innerHTML='<div class="nvy-bis__done"><span><b>'+esc(T('bis_noted','Staat genoteerd.'))+'</b> '+esc(T('bis_noted_first','We sturen je één mailtje zodra deze weer op voorraad is — en jij bent als eerste aan de beurt.'))+'</span></div>';
      } else { throw new Error('status '+r.status); }
    }).catch(function(){
      if(btn) btn.disabled=false;
      var e=document.createElement('div'); e.className='nvy-bis__err'; e.textContent=T('bis_error','Dat ging even mis — probeer het opnieuw of mail info@novyre.nl.');
      panel.appendChild(e);
    });
  }

  function updateBis(){
    var u=firstUnavailable();
    [].forEach.call(document.querySelectorAll('.nvy-buy--b'),function(b){
      var cta=b.querySelector('.nvy-buy__cta');
      var lb=b.querySelector('.nvy-buy__cta-label');
      var panel=b.querySelector('.nvy-bis');
      if(!u){
        if(panel) panel.remove();
        if(cta) cta.classList.remove('is-oos');
        if(lb&&lb.getAttribute('data-oos')){ lb.textContent=T('add','Voeg toe'); lb.removeAttribute('data-oos'); }
        return;
      }
      var vid=u.variant.id;
      if(cta) cta.classList.add('is-oos');
      if(lb){ lb.textContent=T('sold_out','Tijdelijk uitverkocht'); lb.setAttribute('data-oos','1'); }
      if(panel&&panel.getAttribute('data-vid')===String(vid)) return;
      if(panel) panel.remove();
      panel=document.createElement('div'); panel.className='nvy-bis'; panel.setAttribute('data-vid',vid);
      if(bisDone[vid]){
        panel.innerHTML='<div class="nvy-bis__done"><span><b>'+esc(T('bis_noted','Staat genoteerd.'))+'</b> '+esc(T('bis_noted_short','We sturen je één mailtje zodra deze weer op voorraad is.'))+'</span></div>';
      } else {
        var bisTitle=T('bis_title','%colour% in maat %size% is tijdelijk uitverkocht.')
          .replace('%colour%',esc(u.colour)).replace('%size%',esc(u.size));
        panel.innerHTML='<div class="nvy-bis__title">'+bisTitle+'</div>'
          +'<div class="nvy-bis__sub">'+esc(T('bis_sub','Ontvang één mailtje zodra hij er weer is — jij bent dan als eerste aan de beurt.'))+'</div>'
          +'<div class="nvy-bis__row"><input type="email" class="nvy-bis__mail" placeholder="'+esc(T('bis_email','jouw@email.nl'))+'" autocomplete="email"><button type="button" class="nvy-bis__go">'+esc(T('bis_cta','Houd mij op de hoogte'))+'</button></div>'
          +'<div class="nvy-bis__note">'+esc(T('bis_note','Geen nieuwsbrief — alleen dit ene bericht.'))+'</div>';
        var go=panel.querySelector('.nvy-bis__go'), mail=panel.querySelector('.nvy-bis__mail');
        function submit(){
          var em=(mail.value||'').trim();
          if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)){ mail.focus(); mail.style.borderColor='#B0503C'; return; }
          mail.style.borderColor='';
          subscribeBIS(vid,em,panel);
        }
        go.addEventListener('click',submit);
        mail.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); submit(); } });
      }
      var ml=b.querySelector('.nvy-measure-link');
      if(ml){ ml.insertAdjacentElement('afterend',panel); } else { b.insertAdjacentElement('afterbegin',panel); }
    });
  }

  function paint(){
    var u=unitCents();
    packs().forEach(function(p){
      var sel='.nvy-chip[data-qty="'+p.q+'"]';
      [].forEach.call(document.querySelectorAll(sel+' .nvy-chip__price'),function(e){
        if(p.q===1){ e.innerHTML='<b>'+eur(u)+'</b>'; }
        else if(p.off!=null){ e.innerHTML='<b>'+esc(T('second_for','2e voor'))+' '+eur(u-p.off)+'</b>'; }
        else { e.innerHTML='<b>'+eur(perFor(p.q,u))+'</b> '+esc(T('per_unit','p/st')); }
      });
      [].forEach.call(document.querySelectorAll(sel+' .nvy-chip__save'),function(e){
        if(p.q===1){ e.textContent=''; }
        else if(p.off!=null){ e.textContent=T('together','Samen')+' '+eur(u*2-p.off)+' · '+T('save','Bespaar')+' '+eur(p.off); }
        else { e.textContent=T('save','Bespaar')+' '+eur((u-perFor(p.q,u))*p.q); }
      });
    });
    var total=totalCents();
    [].forEach.call(document.querySelectorAll('.nvy-buy__cta-price'),function(e){ e.textContent=eur(total); });
    var st=document.querySelector('.nvy-stick__sub');
    if(st){ st.innerHTML=esc(TQ(state.qty))+' · <b>'+eur(total)+'</b>'; }
    heroSync(); updateBis();
  }

  function syncThemeColour(colour){
    var ins=document.querySelectorAll('variant-selects input');
    for(var i=0;i<ins.length;i++){ if(ins[i].value===colour&&ins[i].checked!==true){ try{ ins[i].click(); }catch(e){} return; } }
  }

  function slotSig(){ return state.qty+'|'+curSize()+'|'+state.colors.join(','); }
  function renderSlots(){
    if(!prod||!colourName) return;
    var cc=curColour();
    while(state.colors.length<state.qty) state.colors.push(cc);
    [].forEach.call(document.querySelectorAll('.nvy-buy__colors'),function(host){
      if(host.getAttribute('data-sig')===slotSig()) return;
      host.setAttribute('data-sig',slotSig());
      var size=curSize(), html='';
      var noun=(prod&&/bh/i.test(prod.type||prod.product_type||''))?T('slot_bra','BH'):T('slot_item','Nr.');
      var colhead=(state.qty===1)?esc(T('pick_colour','Kies je kleur'))
        :T('pick_colours_html','Kies je %count% kleuren <em>— mix zoals jij wilt</em>').replace('%count%',state.qty);
      html+='<div class="nvy-buy__colhead">'+colhead+'</div>';
      for(var i=0;i<state.qty;i++){
        html+='<div class="nvy-slot" data-slot="'+i+'"><span class="nvy-slot__label">'+esc(noun)+' '+(i+1)+'</span><span class="nvy-slot__dots">';
        colourName.values.forEach(function(c){
          var vv=variantFor(c,size); var off=!(vv&&vv.available);
          var im=imgFor(c);
          html+=im?('<img class="nvy-dot'+(state.colors[i]===c?' is-on':'')+(off?' is-off':'')+'" src="'+im+'" alt="'+esc(c)+'" data-c="'+esc(c)+'">')
                 :('<span class="nvy-dot'+(state.colors[i]===c?' is-on':'')+(off?' is-off':'')+'" data-c="'+esc(c)+'" style="background:#ddd"></span>');
        });
        html+='</span><span class="nvy-slot__name">'+esc(state.colors[i]||'')+'</span></div>';
      }
      host.innerHTML=html;
      [].forEach.call(host.querySelectorAll('.nvy-dot'),function(d){
        d.addEventListener('click',function(){
          var slot=parseInt(d.closest('.nvy-slot').getAttribute('data-slot'),10);
          state.colors[slot]=d.getAttribute('data-c');
          syncThemeColour(state.colors[slot]);
          [].forEach.call(document.querySelectorAll('.nvy-buy__colors'),function(h){h.removeAttribute('data-sig');});
          renderSlots(); paint();
        });
      });
    });
  }

  function add(btn){
    if(!prod){ return; }
    var size=curSize(), map={}, i, bad=false;
    for(i=0;i<state.qty;i++){ var c=state.colors[i]||curColour(); var vv=variantFor(c,size);
      if(!vv||!vv.available){ bad=true; break; } map[vv.id]=(map[vv.id]||0)+1; }
    if(bad){ updateBis(); var p=document.querySelector('.nvy-buy--b .nvy-bis'); if(p){ p.scrollIntoView({block:'center',behavior:'smooth'}); var m=p.querySelector('.nvy-bis__mail'); if(m) setTimeout(function(){ m.focus(); },450); } return; }
    var lb=btn.querySelector('.nvy-buy__cta-label');
    var items=Object.keys(map).map(function(id){ return {id:parseInt(id,10),quantity:map[id]}; });
    btn.classList.add('is-loading');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        btn.classList.remove('is-loading'); btn.classList.add('is-done');
        if(lb){ var old=lb.textContent; lb.textContent='✓ '+T('added','Toegevoegd'); setTimeout(function(){ btn.classList.remove('is-done'); lb.textContent=old; },1400); }
        document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
      })
      .catch(function(){ btn.classList.remove('is-loading'); window.location.href='/cart'; });
  }

  function chipHTML(p){
    var tagText=p.tag?T(p.tagKey,p.tag):'';
    var tag=tagText?('<span class="nvy-chip__tag'+(p.gold?'':' nvy-chip__tag--ink')+'">'+esc(tagText)+'</span>'):'';
    var label=TQ(p.q);
    return '<button type="button" class="nvy-chip'+(p.q===state.qty?' is-on':'')+'" data-qty="'+p.q+'">'+tag+'<div class="nvy-chip__qty">'+esc(label)+'</div><div class="nvy-chip__price"></div><div class="nvy-chip__save"></div></button>';
  }

  function openMeasure(){
    var t=document.querySelector('.nvyU__trigger-btn');
    if(!t){ t=[].slice.call(document.querySelectorAll('a,button')).filter(function(e){ return /MEET MIJN ECHTE MAAT/i.test(e.textContent); })[0]; }
    if(t){ try{ t.click(); return; }catch(e){} }
    location.href='/pages/maatadvies';
  }

  function buildModules(){
    [].forEach.call(document.querySelectorAll('.product__blocks'),function(cont){
      var kids=[].slice.call(cont.children), varBlock=null, i;
      for(i=0;i<kids.length;i++){
        if(!varBlock&&kids[i].querySelector&&kids[i].querySelector('variant-selects')){ varBlock=kids[i]; break; }
      }
      if(!varBlock) return;
      if(!cont.querySelector('.nvy-buy--a')){
        var a=document.createElement('div'); a.className='nvy-buy nvy-buy--a';
        var P=packs(), chips=''; P.forEach(function(p){ chips+=chipHTML(p); });
        a.innerHTML='<div class="nvy-buy__chips"'+(P.length===2?' style="grid-template-columns:.9fr 1.4fr"':'')+'>'+chips+'</div><div class="nvy-buy__colors"></div>';
        varBlock.insertAdjacentElement('beforebegin',a);
        [].forEach.call(a.querySelectorAll('.nvy-chip'),function(ch){
          ch.addEventListener('click',function(){
            state.qty=parseInt(ch.getAttribute('data-qty'),10)||1;
            state.colors=state.colors.slice(0,state.qty);
            [].forEach.call(document.querySelectorAll('.nvy-chip'),function(x){ x.classList.toggle('is-on',parseInt(x.getAttribute('data-qty'),10)===state.qty); });
            [].forEach.call(document.querySelectorAll('.nvy-buy__colors'),function(h){h.removeAttribute('data-sig');});
            renderSlots(); paint();
          });
        });
      }
      if(!cont.querySelector('.nvy-buy--b')){
        var b=document.createElement('div'); b.className='nvy-buy nvy-buy--b';
        /* Trust-regel per markt: 'Eerst passen, dan betalen' komt uit nvy.micro.try_first,
           dat in het Kroatisch bewust een retour-claim is en geen Klarna-claim. Lege
           segmenten vallen weg in plaats van terug te vallen op het Nederlands. */
        var trust=[T('trust_days','14 dagen bedenktijd'),T('trust_fit','Eerst passen, dan betalen'),T('trust_returns','Eenvoudig retourneren in Nederland')]
          .filter(function(x){ return x&&String(x).trim(); }).join(' · ');
        b.innerHTML='<div class="nvy-measure-link"><span>📏</span><span>'+T('measure_html','Twijfel je over je maat? <b>Meet ’m in 2 minuten</b> — bestel in één keer goed.')+'</span></div>'
          +'<button type="button" class="nvy-buy__cta"><span class="nvy-buy__cta-label">'+esc(T('add','Voeg toe'))+'</span><span class="nvy-buy__cta-price"></span></button>'
          +'<div class="nvy-buy__trust">'+esc(trust)+'</div>';
        varBlock.insertAdjacentElement('afterend',b);
        var ml=b.querySelector('.nvy-measure-link');
        if(!document.querySelector('.nvyU')&&!document.querySelector('.nvy-meting')){ ml.style.display='none'; }
        ml.addEventListener('click',openMeasure);
        b.querySelector('.nvy-buy__cta').addEventListener('click',function(){ add(this); });
      }
    });
  }

  function rewriteMeasureCard(){
    if(!isNL()) return;
    var card=document.querySelector('.nvy-meting'); if(!card||card.getAttribute('data-nvy-rw')) return;
    var walker=document.createTreeWalker(card,NodeFilter.SHOW_TEXT), n, hits=0;
    while((n=walker.nextNode())){
      var t=n.textContent;
      if(/Jouw cupmaat\?/.test(t)){ n.textContent=t.replace('Jouw cupmaat?','Pak een meetlint.'); hits++; }
      if(/Weet je het echt zeker\?/.test(t)){ n.textContent=n.textContent.replace('Weet je het echt zeker?','Meet. Bestel in één keer goed.'); hits++; }
      if(/Acht op de tien dragen jarenlang de verkeerde maat\./.test(t)){ n.textContent=n.textContent.replace('Acht op de tien dragen jarenlang de verkeerde maat.','Acht op de tien vrouwen dragen de verkeerde maat — 2 minuten meten voorkomt ruilen.'); hits++; }
    }
    if(hits>0) card.setAttribute('data-nvy-rw','1');
  }

  function buildSticky(){
    if(document.querySelector('.nvy-stick')) return;
    var inline=document.querySelector('.nvy-buy__cta'); if(!inline) return;
    var im=document.querySelector('.product__media img,[id^=MediaGallery] img,.product-media img,.swiper-slide img');
    var name=prod?prod.title:((document.querySelector('.nvy-ah__title,h1')||{}).textContent||'Novyre');
    var bar=document.createElement('div'); bar.className='nvy-stick';
    bar.innerHTML='<div class="nvy-stick__in">'+(im?'<img class="nvy-stick__thumb" src="'+(im.currentSrc||im.src)+'" alt="">':'')
      +'<div class="nvy-stick__info"><div class="nvy-stick__name">'+esc(String(name).trim())+'</div><div class="nvy-stick__sub"></div></div>'
      +'<button type="button" class="nvy-stick__cta">'+esc(T('add','Voeg toe'))+'</button></div>';
    document.body.appendChild(bar);
    bar.querySelector('.nvy-stick__cta').addEventListener('click',function(){ var b=document.querySelector('.nvy-buy--b .nvy-buy__cta'); if(b) add(b); });
    function chk(){ var b=null, all=document.querySelectorAll('.nvy-buy__cta'); for(var i=0;i<all.length;i++){ if(all[i].offsetParent!==null){ b=all[i]; break; } } if(b){ bar.classList.toggle('on', b.getBoundingClientRect().bottom<0); } }
    window.addEventListener('scroll',chk,{passive:true}); window.addEventListener('resize',chk,{passive:true}); chk();
  }

  document.addEventListener('variant:changed',function(){
    [].forEach.call(document.querySelectorAll('.nvy-buy__colors'),function(h){h.removeAttribute('data-sig');});
    renderSlots(); paint();
  });

  /* Koopzone: veilig tijdens het parsen (idempotent, geen clones). */
  function tickBuy(){
    if(!CFG.handle){ readCFG(); synthProd(); }
    injectUSPs(); buildModules(); renderSlots(); buildSticky(); paint();
  }
  /* Onder-de-vouw swaps: pas ná volledige parse — deze klonen/tellen DOM-items en zouden
     op een half-geparste sectie dubbele FAQ-items opleveren. */
  function tickBelow(){
    rewriteMeasureCard(); swapFAQ(); swapWhy(); fixReviewHeading(); fixBrandClaims();
  }
  function tick(){ tickBuy(); if(document.readyState!=='loading') tickBelow(); }

  /* Streaming boot: dit script is async en draait meestal al terwijl de HTML (1,2MB) nog
     binnenstroomt. Bouw de koopmodule zodra de variant-picker in de DOM staat — wachten op
     DOMContentLoaded kost hier honderden ms tot seconden extra. */
  var pollStarted=false;
  function startPoll(){
    if(pollStarted) return; pollStarted=true;
    tick();
    var n=0, iv=setInterval(function(){ n++; tick(); if(n>50){ clearInterval(iv); } },250);
  }
  function boot(){
    if(document.readyState!=='loading'){ startPoll(); return; }
    if(document.body&&document.querySelector('.product__blocks variant-selects')){ tick(); setTimeout(boot,120); }
    else { setTimeout(boot,40); }
  }
  boot();
  document.addEventListener('DOMContentLoaded',startPoll);
})();
